import React, { useEffect } from 'react'
import Card from '../components/Card'
import Masonry from 'react-masonry-css'
import { useDispatch, useSelector } from 'react-redux'
import { fetchArtworks } from '../store/actions/artwork'
import { useLocation } from 'react-router-dom'
import ReactLoading from "react-loading";

function Home() {
  const artworks = useSelector(state => state.artwork.artworks)
  const loading = useSelector(state => state.artwork.loading)
  const error = useSelector(state => state.artwork.error)
  const location = useLocation()
  console.log(location)
  const dispatch = useDispatch()

  useEffect(() => {
   if (!location.state) {
     dispatch(fetchArtworks())
   }
  }, [dispatch, location.state])

  if (artworks) {
    let iiif_url
    if (artworks.config) {
      iiif_url = artworks.config.iiif_url
    } else {
      iiif_url = "https://www.artic.edu/iiif/2"
    }
    artworks.data.forEach(e => {
      e.imageUrl = iiif_url + '/' + e.image_id + '/full/843,/0/default.jpg'
    })
  }
  
  const breakpointCols = {
    default: 4,
    1100: 2,
    700: 1
  }

  return (
    <div>
      <div className="py-5">
        <div className="container">
          <div>
            {
              error ? <p>Something went wrong.</p> : null
            }
            {
              loading ? 
                <div className="vh-100">
                  <div className="position-absolute top-50 start-50 translate-middle">
                    <ReactLoading type="spin" color="#0f0f0f"/>
                  </div>
                </div>
                :
                artworks ?
                  <Masonry
                    breakpointCols={breakpointCols}
                    className="my-masonry-grid"
                    columnClassName="my-masonry-grid_column"
                  >
                    {artworks.data.map(e => 
                      <div key={e.id}>
                        <Card artwork={e}/>
                      </div>
                    )}
                  </Masonry>
                  :
                  null
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home